import React, { useState } from 'react';
import NewAccount from './NewAccount';
import RewardBundle from './RewardBundle';


const Home: React.FC = () => {

  const [selectedStatus, setSelectedStatus] = useState<string>('no');
  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedStatus(event.target.value);
  };

  return (
  <>
    <div className="container">
          <header>
            <div className="row">
              <div>
                <img src="/logo.png" alt="Star Realms Logo" />
              </div>
              <div className="col align-self-center">
                <h1>Star Realms Code Activation</h1>
				<p>Do you have a Star Realms account?</p>
				
				<input type="radio" id="accountyes" name="haveaccount" value="yes" checked={selectedStatus === 'yes'} onChange={handleRadioChange}/>  <label htmlFor="accountyes">Yes</label><br/>
				<input type="radio" id="accountno" name="haveaccount" value="no" checked={selectedStatus === 'no'} onChange={handleRadioChange}/>  <label htmlFor="accountno">No</label><br/>
				<input type="radio" id="accountmaybe" name="maybe" value="maybe" checked={selectedStatus === 'maybe'} onChange={handleRadioChange}/>  <label htmlFor="accountmaybe">Maybe?</label><br/>
              </div>
            </div>
			<div className="row">
			<details>
					<summary>Help</summary>
					<ul>
					<li>Base Set codes may only be used when creating a new account. Select the "No" option above, then enter your Base Set code along with your email address, username that you'd like to use, and your password.<br/>
					 If you already have a Star Realms account, select “Yes”, and continue to submit your other code. You can later send your Base Set Code along with the link to this page to a friend to redeem the Base Set Code.<br/>&nbsp;</li>
					<li>Conquest & Commanders, Everything New, and Follower Promo codes may only be claimed by existing accounts. Use the "Yes" option above, then enter your reward bundle code and your account username and password.<br/>&nbsp;</li>
					<li>Legend account codes can either be used to create a new account or can be used to add Legend status to an existing account. Make sure to select the correct option from the "Do you have a Star Realms account" selector before entering your account information.<br/>&nbsp;</li>
					<li>After you've claimed one code, if you have other codes that you still need to claim please either refresh the web page or tap the Claim Another Code button.</li>
					</ul>
				</details>
			</div>
          </header>
		  <br/>
			<main>
				{/* Conditionally render based on selectedStatus */}
				{selectedStatus === 'yes' && <div>
				<RewardBundle></RewardBundle>
				</div>}
				{selectedStatus === 'no' && <div>
				<NewAccount></NewAccount>
				</div>}
				{selectedStatus === 'maybe' && <div>The Star Realms app has been around for over 10 years!<br/>If you made (or think you made) an account in the past but can't remember your username, maybe used an old email address, or have some other problem with your account, please contact <a href="mailto:support@wisewizardgames.com?subject=Star Realms Account Help">support@wisewizardgames.com</a>.<br/>We'll do our best to help you get back into the game!
				</div>}
			</main>
			<br/>
      </div>
	</>
  );
};

export default Home;
